import React from 'react';
import './WhatsNewItem.pcss';
import { ReactComponent as ArrowIcon } from 'assets/icons/blue-right-arrow.svg';
import moment from 'moment';
import { ImageMessage } from '../../../../../features/liveChat/components/Messages/ImageMessage/ImageMessage';

type Props = {
  id: number;
  createdAt: string;
  title: string;
  text: string;
  imageUrl?: string;
  link?: string;
};

export const WhatsNewItem = ({
  id,
  createdAt,
  title,
  text,
  imageUrl,
  link,
}: Props) => {
  return (
    <div className="whats-new-item" key={id}>
      <div className="whats-new-item__date">
        {moment(createdAt).format('MM/DD/YYYY')}
      </div>
      <div className="whats-new-item__title">{title}</div>
      <div className="whats-new-item__text">{text}</div>
      {imageUrl && (
        <div className="whats-new-item__image-div">
          <ImageMessage url={imageUrl} />
        </div>
      )}
      {link && (
        <div className="whats-new-item__link" onClick={() => window.open(link)}>
          <span>Check it out</span>
          <span className="whats-new-item__icon">
            <ArrowIcon />
          </span>
        </div>
      )}
    </div>
  );
};
